import { ISectionName } from 'my-poppies-b2b-types';
import { FC } from 'react';

import { AddNewInternalOrderButton } from '@/components/RootScreenButtons/AddNewInternalOrderButton';
import { AddNewOrderButton } from '@/components/RootScreenButtons/AddNewOrderButton';
import { AddNewPaymentButton } from '@/components/RootScreenButtons/AddNewPaymentButton';
import { AddNewPreorderButton } from '@/components/RootScreenButtons/AddNewPreorderButton';
import { GoToArchiveButton } from '@/components/RootScreenButtons/GoToArchiveButton';
import { GoToOptionsButton } from '@/components/RootScreenButtons/GoToOptionsButton';
import { GoToPositionsButton } from '@/components/RootScreenButtons/GoToPositionsButton';
import { SectionDeclinedOrders } from '@/sections/SectionDeclinedOrders';
import { SectionGuideline } from '@/sections/SectionGuideline';
import { SectionNewOrders } from '@/sections/SectionNewOrders';
import { SectionOrderOverview } from '@/sections/SectionOrderOverview';
import { SectionPayments } from '@/sections/SectionPayments';
import { SectionPreorderOverview } from '@/sections/SectionPreorderOverview';

type ISectionMapping = Record<ISectionName, FC | null>;

export const sectionMapping: ISectionMapping = {
  NEW_ORDERS: SectionNewOrders,
  DECLINED_ORDERS: SectionDeclinedOrders,
  ADD_NEW_ORDER: AddNewOrderButton,
  ADD_NEW_PREORDER: AddNewPreorderButton,
  ADD_NEW_INTERNAL_ORDER: AddNewInternalOrderButton,
  ADD_NEW_PAYMENT: AddNewPaymentButton,
  CONTACT_LIST: null,
  GUIDELINE: SectionGuideline,
  ORDER_OVERVIEW: SectionOrderOverview,
  PREORDER_OVERVIEW: SectionPreorderOverview,
  ARCHIVE: GoToArchiveButton,
  PAYMENTS: SectionPayments,
  ACCOUNT: null, // we display the avatar button in the AppHeader instead!
  OPTIONS: GoToOptionsButton,
  POSITIONS: GoToPositionsButton,
};
